import "./css/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./frontend/components/Navbar";
import Footer from "./frontend/components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import LandingPage from "./frontend/pages/LandingPage";
import AboutUsPage from "./frontend/pages/AboutUsPage";
import MortgagePage from "./frontend/pages/MortagePage";
import {ProtectionPage} from "./frontend/pages/ProtectionPage";
import ContactUsPage from "./frontend/pages/ContactUsPage";
import PrivacyPage from "./frontend/pages/PrivacyPage";
import TermsAndConditionsPage from "./frontend/pages/TermsAndConditionsPage";
import { OtherServicesPage } from "./frontend/pages/OtherServicesPage";
import BlogPage from "./frontend/pages/BlogPage";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/mortgages" element={<MortgagePage />} />
          <Route path="/protection" element={<ProtectionPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/other-services" element={<OtherServicesPage />} />
          {/* <Route path="/blogs" element={<BlogPage />} /> */}
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
